import joi from 'joi';

import type { DeviceType } from '../nodes/constants';
import type { GroupEdgeSettings, TopologyEdgeSettings } from './EdgeSettings';
import {
  type HideableNodeType,
  hideableNodeTypeSchema,
} from './HideableNodeType';
import type { PresetId } from './PresetId';
import {
  generateEdgeSettingsSchemas,
  graphEdgeSettingsStyleSchema,
} from './generateEdgeSettingsSchema';

export type GraphHiddenDeviceTypes = DeviceType[];

export type TopologyGraphEdgeSettings =
  | GroupEdgeSettings
  | TopologyEdgeSettings;
export type TopologyGraphEdgesSettings = TopologyGraphEdgeSettings[];
/**
 * Exported as a list instead of working schema, use Joi.alternatives to make it working schema
 * or incorporate into member array via .items(...topologyEdgeSettingsSchemas)
 */
export const topologyEdgeSettingsSchemas =
  generateEdgeSettingsSchemas('protocol');

export const groupEdgeSettingsSchema = joi.object().keys({
  children: joi
    .array()
    .items(...topologyEdgeSettingsSchemas)
    .min(1)
    .required(),
  grouped: joi.boolean().required(),
  id: joi.string().guid().required(),
  label: joi.string().required(),
  name: joi.string().required(),
  style: graphEdgeSettingsStyleSchema.required(),
  type: joi.valid('group').required(),
  visible: joi.boolean().required(),
  labelsOptions: joi.object().keys({
    wrapCenterLabel: joi.boolean(),
    wrapLinecapLabel: joi.boolean(),
  }),
});

export const graphEdgesSettingsSchema = joi
  .array()
  .items(...topologyEdgeSettingsSchemas, groupEdgeSettingsSchema);

export interface TopologyGraphSettings {
  edges: TopologyGraphEdgesSettings;
  hiddenDeviceTypes: HideableNodeType[];
}

export const topologyGraphSettingsSchema = joi.object().keys({
  edges: graphEdgesSettingsSchema.required(),
  hiddenDeviceTypes: joi.array().items(hideableNodeTypeSchema).required(),
});

export interface TopologyGraphPreset extends TopologyGraphSettings {
  factory: boolean;
  id: PresetId;
  name: string;
}

export const topologyGraphPresetSchema = topologyGraphSettingsSchema.keys({
  factory: joi.boolean().required(),
  id: joi.string().required(),
  name: joi.string().required(),
});
